export default "/images/1ceebb5a2492459e83ec33ad7be98893.avif";